var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6234 15.0037L21.2249 15C18.5302 15 16.7888 16.7387 16.7888 19.4298V21.4723H14.3771C14.1688 21.4723 14 21.6367 14 21.8395V24.7988C14 25.0016 14.1689 25.1658 14.3771 25.1658H16.7888V32.633C16.7888 32.8358 16.9575 33 17.1659 33H20.3124C20.5208 33 20.6896 32.8356 20.6896 32.633V25.1658H23.5093C23.7177 25.1658 23.8865 25.0016 23.8865 24.7988L23.8876 21.8395C23.8876 21.7421 23.8478 21.6489 23.7772 21.5799C23.7066 21.511 23.6103 21.4723 23.5103 21.4723H20.6896V19.7409C20.6896 18.9087 20.8933 18.4862 22.0073 18.4862L23.623 18.4857C23.8312 18.4857 24 18.3212 24 18.1186V15.3708C24 15.1683 23.8314 15.0041 23.6234 15.0037Z",
    fill: "#ED1C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook1);
export default __webpack_public_path__ + "static/media/Facebook(1).7a902c9043fe0907789e26f8b89cde82.svg";
export { ForwardRef as ReactComponent };